import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <p className="cta-text">Have Questions? Talk to Our Experts Today!</p>
        <button className="contact-btn">Contact Us ></button>
      </div>
    </section>
  );
};

export default CTA;
